import { render, staticRenderFns } from "./game-tab.vue?vue&type=template&id=ae3b5a0e&scoped=true&"
import script from "./game-tab.vue?vue&type=script&lang=ts&"
export * from "./game-tab.vue?vue&type=script&lang=ts&"
import style0 from "./game-tab.vue?vue&type=style&index=0&id=ae3b5a0e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae3b5a0e",
  null
  
)

export default component.exports